/**
 * Centralized application route paths.
 *
 * Single source of truth for navigation targets so we never scatter
 * route string literals across services, guards and components.
 */
export const APP_ROUTES = {
  SALES_MANAGER_HOME: '/sales-manager-home',
  EVENTS_SELLER: '/events/seller',
  EVENTS_SELLER_ACTIVE: '/events/seller/active-events',
  EVENTS_RECEPCIONIST: '/events/recepcionist',
  DASHBOARD_SELLER: '/dashboard-seller',
  MULTI_EVENT_TICKETS: '/event-sales/multi-event-tickets',
  BIRTHDAYS: '/birthdays',
  APP_VERSION_ADMIN: '/app-version-admin',
  LOGIN: '/login',
  NOT_FOUND: '/notfound',
  SELECTION_ROLE: '/selection/role',
  INBOX: '/inbox',
  INBOX_PREFERENCES: '/inbox/preferences',
  ACCOUNT: '/account',
  USER_PROFILE: '/user-profile',
  ADMINISTRATION: '/administration',
  ADMINISTRATION_SELLERS: '/administration/sellers',
  CHANGE_PASSWORD: '/user-profile/change-password',
  TURNSTILE_EVENTS_LIST: '/turnstile-events-list',
  TURNSTILE_MANAGEMENT: '/turnstile-management',
  QR_STATUS: '/qr-status',
} as const;

export type AppRoute = typeof APP_ROUTES[keyof typeof APP_ROUTES];
